import {AfterViewInit, Directive, ElementRef, Input, Renderer2} from '@angular/core';
import {UploaderService} from "../services/uploader.service";

@Directive({
  selector: '[file]'
})
export class FileDirective implements AfterViewInit {
  @Input() type: string;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private upload: UploaderService
  ) {}

  ngAfterViewInit() {
    // open file window on element click
    this.renderer.listen(this.el.nativeElement, 'click', e => {
      this.upload.browse(this.type);
    });
  }

}


// WEBPACK FOOTER //
// /code/frontend/src/app/shared/directives/file.directive.ts